import { StatusChange } from '../enums/status-change.enum';

// map statusChange id from fundStats config to StatusChange 
export const statusChangeMapping = {
	'upgraded': StatusChange.UPGRADE,
	'downgraded': StatusChange.DOWNGRADE
};
